import React from "react";

export interface ITaskContext {
	name?: string;
	id?: number;
	canBeUnassigned?: boolean;
	canBeReassigned?: boolean;
	canSaveTask?: boolean;
	busy: boolean;
	close: () => void;
	save: () => void;
	complete: () => void;
	saveAndClose: () => void;
	unassignTask: () => void;
	validationErrors: boolean;
	canDeleteActivity?: boolean;
	deleteActivity: () => void;
	assignee?: string;
	startDate?: string;
	dueDate?: string;
}

export default React.createContext<Partial<ITaskContext>>({});
